import React, { useState, useCallback, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";

import {
  StepOneComponent,
  StepTwoComponent,
  StepThreeComponent,
  PatientOrgStepThree,
  StepFourComponent,
  StepFiveComponent,
} from ".";
import styles from "./styles.module.scss";
import { Button, BtnType } from "../../primitives";
import { projectNew, clearNewProject } from "../project/project.action";
import { steps } from "./constant";
import { setFilters } from "../../companies/companyMain/companyMain.action";
import { projectStagesTemplatesGet } from "modules/projects/newProject/stepOne/stepOne.actions";

const NewProjectComponent = (props) => {
  const [CurrentStep, setCurrentStep] = useState(steps.step_one);
  const formRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const [newProject, setNewProject] = useState({});
  const [nextButton, setNextButton] = useState("Next");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [update, setUpdate] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const {
    councilReducer: { selectedCouncil },
    projectsReducer: {
      projectReducer: { newProjectObject },
    },
    stepOneReducer: { stageTemplates },
  } = useSelector((state) => state);

  useEffect(() => {
    if (props.model) {
      setNewProject(props.model);
    }
  }, [props?.model])

  useEffect(() => {
    if (!stageTemplates?.length && selectedCouncil) {
      dispatch(
        projectStagesTemplatesGet({
          council_id: selectedCouncil.id,
          enqueueSnackbar,
        })
      );
    }
  }, [selectedCouncil, stageTemplates]);

  useEffect(() => {
    localStorage.removeItem("new_project");
  }, []);

  useEffect(
    () => () => {
      localStorage.removeItem("new_project");
      localStorage.removeItem("new_project_object");
      setUpdate(true);
      dispatch(clearNewProject());
      dispatch(
        setFilters({
          topic_ids: [],
          industry_ids: [],
          disease_ids: [],
          country_ids: [],
        })
      );
    },
    []
  );

  useEffect(() => {
    if (newProjectObject) {
      const projObj = JSON.parse(localStorage.getItem("new_project_object"));
      history.push(`/projects/${projObj && projObj.id}/overview`);

      if (props.handleClose) {
        props.handleClose();
      }
    }
  }, [newProjectObject]);

  window.onbeforeunload = function (e) {
    localStorage.removeItem("new_project");
    localStorage.removeItem("new_project_object");
    dispatch(clearNewProject());
    dispatch(
      setFilters({
        topic_ids: [],
        industry_ids: [],
        disease_ids: [],
        country_ids: [],
      })
    );
    setUpdate(false);
  };

  const handleBackClick = () => {
    if (props.gskModalInstance) {
      setCurrentStep((prev) => prev - 1);

      return;
    }

    if (CurrentStep !== steps.step_one) {
      setCurrentStep((prev) => prev - 1);
      setNextButton("Next");
    } else {
      history.push(props.location.state?.from);
    }
  };

  const handleNextClick = () => {
    const projObj = JSON.parse(localStorage.getItem("new_project"));
    if (formRef.current) {
      formRef.current.handleSubmit();
    } else if (
      CurrentStep !== steps.step_five &&
      projObj &&
      projObj.stage_template_id.obj[0].default_patient_organization !== true
    ) {
      setCurrentStep((prev) => prev + 1);
    } else if (
      CurrentStep !== steps.step_six &&
      projObj &&
      projObj.stage_template_id.obj[0].default_patient_organization
    ) {
      setCurrentStep((prev) => prev + 1);
    }
    if (
      CurrentStep === steps.step_four &&
      projObj &&
      projObj.stage_template_id.obj[0].default_patient_organization !== true
    ) {
      setNextButton("Done");
    } else if (
      CurrentStep === steps.step_five &&
      projObj &&
      projObj.stage_template_id.obj[0].default_patient_organization
    ) {
      setNextButton("Done");
    }
    if (
      CurrentStep === steps.step_five &&
      projObj &&
      projObj.stage_template_id.obj[0].default_patient_organization !== true
    ) {
      const new_project = JSON.parse(localStorage.getItem("new_project"));
      setIsSubmitted(true);
      dispatch(projectNew({ enqueueSnackbar, ...new_project }));
    } else if (
      CurrentStep === steps.step_six &&
      projObj &&
      projObj.stage_template_id.obj[0].default_patient_organization
    ) {
      const new_project = JSON.parse(localStorage.getItem("new_project"));
      setIsSubmitted(true);
      dispatch(projectNew({ enqueueSnackbar, ...new_project }));
    }
  };

  const moveNextStep = (step, value) => {
    const new_project = localStorage.getItem("new_project");
    if (!new_project) {
      localStorage.setItem("new_project", JSON.stringify(value));
    } else {
      let obj = JSON.parse(new_project);
      obj = { ...obj, value };
      localStorage.setItem("new_project", JSON.stringify(obj));
      setNewProject(obj);
    }
    setCurrentStep(step);
  };

  const getStepWindow = useCallback(() => {
    const projObj = JSON.parse(localStorage.getItem("new_project"));
    switch (CurrentStep) {
      case steps.step_one:
        return (
          <StepOneComponent
            formRef={formRef}
            moveNextStep={moveNextStep}
            defultModel={newProject}
            mode={props.gskModalInstance ? 'modal' : null}
          />
        );
      case steps.step_two:
        return <StepTwoComponent />;
      case steps.step_three:
        return <StepThreeComponent />;
      case steps.step_four:
        if (
          projObj &&
          projObj.stage_template_id.obj[0].default_patient_organization
        ) {
          return <PatientOrgStepThree step={4} />;
        }
        return <StepFourComponent update={update} setUpdate={setUpdate} />;

      case steps.step_five:
        if (
          projObj &&
          projObj.stage_template_id.obj[0].default_patient_organization
        ) {
          return (
            <StepFourComponent update={update} setUpdate={setUpdate} step={5} />
          );
        }
        return <StepFiveComponent />;

      case steps.step_six:
        if (
          projObj &&
          projObj.stage_template_id.obj[0].default_patient_organization
        ) {
          return <StepFiveComponent step={6} />;
        }
        break;

      default:
        break;
    }
  }, [CurrentStep, newProject, props, moveNextStep, formRef]);

  return (
    <div className={styles.wrapper}>
      {
        !props.gskModalInstance && (
          <div className={styles.titleWrp}>
            <h4 className={styles.title}>Start A New Project</h4>
          </div>
        )
      }
      <div className={`${props.gskModalInstance ? 'mt-0 d-flex align-items-center justify-content-center' : styles.container}`}>
        {isSubmitted && (
          <div className={props.gskModalInstance ? 'col-12 p-0' : 'col-md-6'}>
            <h3>
              Please wait a moment as we pull everything together to create your
              project
            </h3>
          </div>
        )}
        {!isSubmitted && (
          <div className={props.gskModalInstance ? 'col-12 p-0' : 'col-md-6'}>
            <div className={styles.captionStyle}>
              Step
              {" " + CurrentStep} of 6
            </div>
            {getStepWindow()}
            <div className={props.gskModalInstance ? 'd-flex justify-content-end' : styles.btnWrap}>
              <div className={styles.btnBack}>
                {
                  props.gskModalInstance && CurrentStep === steps.step_one ? (
                    <Button btn={BtnType.FRAME_LESS} onClick={() => props.handleClose()}>
                      Close
                    </Button>
                  ) : (
                    <Button btn={BtnType.FRAME_LESS} onClick={handleBackClick}>
                      Back
                    </Button>
                  )
                }
              </div>
              <div className={styles.btnNext}>
                <Button
                  btn={BtnType.FRAME_LESS}
                  className={styles.skipButton}
                  onClick={handleNextClick}
                >
                  Skip
                </Button>
                <Button
                  btn={BtnType.REGULAR}
                  className="ml-2"
                  onClick={handleNextClick}
                >
                  {nextButton}
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(NewProjectComponent);
